import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { Callout, RadioCardGroup, StepActions, PageHeader } from "@components/ui_v2";
import { PATHS_TOFU_V2 } from "@helpers/constantes";

export const ConexionCuentas = () => {
  const navigate = useNavigate();
  const [operaConSistemas, setOperaConSistemas] = useState<boolean | null>(null);

  const onBack = () => navigate(PATHS_TOFU_V2.presenciaDigital.path);
  const onNext = () => navigate(PATHS_TOFU_V2.datosAccionista.path);

  return (
  <Box>
    <PageHeader
      eyebrow="Conexión de cuentas"
      title="Mejora tu calificación crediticia"
      subtitle="Si operas con algún sistema o software empresarial, conéctalo de forma opcional para robustecer tu perfil y obtener mejores condiciones. La conexión es de solo lectura y puedes revocarla cuando quieras."
    />

    <Box sx={{ bgcolor: "background.paper", border: "1px solid", borderColor: "background.paper", borderRadius: 2, p: 3, mb: 2 }}>
      <Typography variant="body2" fontWeight={700} color="primary.dark" sx={{ mb: 1 }}>
        ¿Operas con algún sistema o software empresarial?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Marketplaces, ERP, contabilidad o facturación electrónica. Es opcional, pero conectarlos mejora tu evaluación.
      </Typography>
      <RadioCardGroup
        value={operaConSistemas === null ? "" : operaConSistemas ? "si" : "no"}
        onChange={(v) => setOperaConSistemas(v === "si")}
        layout="row"
        options={[
          { value: "si", label: "Sí" },
          { value: "no", label: "No" },
        ]}
      />
    </Box>

    <Callout tone="neutral">Conexión segura de solo lectura. Tú controlas los permisos y puedes revocarlos en cualquier momento.</Callout>

    <StepActions onBack={onBack} onNext={onNext} nextDisabled={operaConSistemas === null} />
  </Box>
  );
};
